<template>
    <div class="noDeliver" :style="{zIndex: zIndexNum,}">
      <!-- <div v-if="name" class="unavailable" :class="getDFLANG() ? 'en' : ''">{{ TLang(name, 'address') }}</div>
      <img class="unavailableImg" v-else src="../assets/imgs/Undelivery.png" alt=""> -->
      <div class="restock-text" :class="['restock-text',getDFLANG()?'no-deliver-font-12':'']" >{{getDFLANG()?'Unavailable': '不可配送'}}</div>
    </div>
</template>
  
  <script>
  import { TLang } from '../utils/lang';
  import {
    checkUnifyShop,
  unionFlag,
} from "../utils";
import { publicFunc } from "../utils/func";
  export default {
    props: {
      zIndexNum: {
        type: Number,
        required: false,
      },
      name: {
        type: String,
        default: ''
      },
    },
    methods: {
      getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return publicFunc.getCookie("df_lang") == "en-US" && (union || checkUnifyShop());
    },
    }
  };
  </script>
  
  <style lang="less" scoped>
  @375: 320/375;
  .noDeliver {
    position: absolute;
    width: 100%;
    display: flex;
    height: 100%;
    top: 0;
    left: 0;
    z-index:10;
    justify-content: center;
    align-items: center;
    .restock-text{
      width: 70px;
      height: 28px;
      line-height: 28px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 14px ;
      font-size: 14px * @375;
      font-weight: 400;
      color: #FFFFFF;
    }
    .no-deliver-font-12{
      font-size: 12px * @375;
    }
    .unavailable{
      display: block;
      width: 64px * @375;
      height: 24px * @375;
      line-height: 24px * @375;
      text-align: center;
      background: rgba(0,0,0,0.5);
      border-radius: 16px * @375;
      font-size: 13px * @375;
      color: #fff;
    }
    .en {
      width: 80px * @375;
    }
    .unavailableImg {
      display: block;
      width: 125px * @375;
      height: 125px * @375;
    }
  }
  </style>
  